<style scoped lang="scss">
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
        font-size: 16px;
      }
    }
  }
  @media screen and (max-width: 640px){
    .wrap-tec .area li{
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .tc,.table{
      margin-top: 20px!important;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_13.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>宏基因组</h1>-->
<!--          <h2 class="mt10">Macrogenome（二代+三代）</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>宏基因组</h1>
      <h2 class="mt10">Macrogenome（二代+三代）</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">宏基因组学（Metagenomics），是利用新一代高通量测序技术（NGS）以特定环境下微生物群体基因组为研究对象，在分析微生物多样性、
        种群结构、进化关系的基础上，进一步探究微生物群体功能特性、相互协作关系及与环境之间的关系，发掘潜在的生物学意义。与传统微生
        物研究方法相比，宏基因组测序技术规避了绝大部分微生物不能培养、痕量菌无法检测的缺点，近年来在环境微生物学研究应用广泛。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/macrogenome_icon_1.png">
            <p>医学领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_2.png">
            <p>畜牧领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_3.png">
            <p>农业领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_4.png">
            <p>环境领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_5.png">
            <p>生物能源</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_6.png">
            <p>特殊极端环境</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/macrogenome_icon_1.png">
            <p>医学领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_2.png">
            <p>畜牧领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_3.png">
            <p>农业领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_4.png">
            <p>环境领域</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_5.png">
            <p>生物能源</p>
          </li>
          <li>
            <img src="@/assets/images/macrogenome_icon_6.png">
            <p>特殊极端环境</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <table class="table">
        <tr>
          <td style="width:350px;">参数</td>
          <td>宏基因组测序</td>
        </tr>
        <tr>
          <td>技术平台</td>
          <td>Illumina测序</td>
        </tr>
        <tr>
          <td>DNA质检</td>
          <td>双链DNA浓度 > 10 ng/μL，总量 > 200 ng</td>
        </tr>
        <tr>
          <td>测序策略</td>
          <td>Illumina Novaseq测序，PE150文库</td>
        </tr>
        <tr>
          <td>组装指标</td>
          <td>视具体情况决定</td>
        </tr>
        <tr>
          <td>项目周期</td>
          <td>40个工作日</td>
        </tr>
      </table>
      <div class="c-title">技术路线</div>
      <div class="tc"><img src="@/assets/images/macrogenome_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/macrogenome.vue